import { render } from "./AdditionalInformation.vue?vue&type=template&id=6c118345&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=6c118345&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c118345"]])

export default __exports__